import { Pipe, PipeTransform } from '@angular/core';
import { Question } from '@empathy/survey-core';

@Pipe({
  name: 'cardText',
  pure: true
})
export class CardTextPipe implements PipeTransform {
  transform(cardId: string, question: Question): string {
    const selectedCard = question.cards.find((opt) => opt.id === cardId);

    return selectedCard?.text;
  }
}
